import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { Location } from '@angular/common';

@Component({
  selector: 'app-reg-form-header',
  templateUrl: './reg-form-header.component.html',
  styleUrls: ['./reg-form-header.component.scss']
})

export class RegFormHeaderComponent implements OnInit {

  @Input() heading = 'Create Account';
  loginStatus: boolean = false;
  queryParams: any;
  showAvatarDropdown: boolean = false;
  facilityName: string;
  currentURL: string;

  constructor(private router: Router, private route: ActivatedRoute, private location: Location,) {
    // console.log('loginStatus', sessionStorage.getItem("loginStatus"));
    this.loginStatus = sessionStorage.getItem("loginStatus") == 'true' ? true : false;
    this.facilityName = sessionStorage.getItem("facility name")
    this.currentURL = router.url;
    this.queryParams = this.route.snapshot.queryParams;
    
    let q = Object.keys(this.queryParams)
    if (q.length > 0) {
      let decodedStr = atob(`${q[0]}`);
      // console.log('qq', decodedStr);
      let properties = decodedStr.split('&');
      let obj = {};
      properties.forEach(function (property) {
        let tup = property.split('=');
        obj[tup[0]] = tup[1];
      });
      this.queryParams = obj;
    }
    // console.log('after decrypted in reg header', this.queryParams);
  }

  ngOnInit(): void {
  }

  backIconClick() {
    if (this.currentURL == '/login/payment') {
      this.router.navigate(['/welcome-login'])
    } else if (this.queryParams.isDisable) {
      this.router.navigateByUrl('welcome-login');
    } else {
      this.router.navigateByUrl('');
    }
  }

  loginClick() {
    this.router.navigateByUrl('login')
  }

  redirectToDetailRegister() {

    if (this.currentURL == '/login/payment') {
      this.router.navigate(['/welcome-login'])
      // this.location.back();
    }

  }

  logoutClick() {
    sessionStorage.clear();
    this.router.navigateByUrl('dashboard');
    Swal.fire("Success", 'Logged out successfully', 'success');
  }
}
